var process = null;
var track = null;
var conclude = null;
var timeout = null;

var BentoSMB = {
    Track: {
        RebateTrack: (`
            <script></script>
        `),
        RegisterTrack: (`
            <script></script>
        `),
    },
    Function: {
        InitRebateSubmission: (attempts = 0) => {
            try {
                const container = document.querySelector('#BentoSMB__Container');
                container.innerHTML = BentoSMB.Element.RebateFormSuccess;

                const title = document.querySelector('title');
                title.innerHTML = 'Rebate Submission - Natural Gas Connection';
            } catch {
                if (attempts < 10) {
                    setTimeout(() => BentoSMB.Function.InitRebateSubmission(attempts + 1), 100);

                    return;
                }
            }

            if (conclude !== null) conclude();
        },
        InitRegisterComplete: (attempts = 0) => {
            try {
                const container = document.querySelector('body');
                container.style = 'display: none;';

                const title = document.querySelector('title');
                title.innerHTML = 'Register Complete - Natural Gas Connection';
            } catch {
                if (attempts < 10) {
                    setTimeout(() => BentoSMB.Function.InitRegisterComplete(attempts + 1), 100);

                    return;
                }
            }

            if (conclude !== null) conclude();
        },
        RedirectRegisterComplete: () => {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
          
            setTimeout(
                () => {
                    window.location.href = params.redirect || '/';
                },
                500,
            );
        },
    },
    Element: {
        RebateFormSuccess: (`
            <style>
                .powr-form-builder iframe {
                    display: none !important;
                }
    
                .powr-form-builder .js-afterSubmissionForm-toggle {
                    padding: 8rem;
                }
    
                .powr-form-builder .formImage {
                    max-height: 600px;
                }
            </style>
    
    
            <div class="hid js-afterSubmissionForm-toggle afterSubmissionContainer" style="display: block;">
                <div class="afterSubmissionMessage pad-top-l pad-bottom-s pad-h-l js-afterSubmissionMessage  " data-qa="afterSubmissionMessage">
                    <figure style="text-align:center" class="margin-bottom-l">
                        <img class="formImage" loading="lazy" data-qa="afterSubmissionImage" src="https://powr.s3-us-west-1.amazonaws.com/images/checkmark.png" style="width:20%">
                    </figure>
                    <div class="text-center margin-bottom-l">
                        <h4 style="font-size: 20px" class="margin-bottom-l" data-qa="successText">Your submission has been received!</h4>  
                    </div>
                </div>
            </div>
        `),
    },
}

function init () {
    if (window.location.pathname === '/pages/financing-rebates/submission_received' || window.location.pathname === '/pages/rebates-only/submission_received') {
        timeout = 1000;
        process = BentoSMB.Function.InitRebateSubmission;
        track = BentoSMB.Track.RebateTrack;
    } else if (window.location.pathname === '/account/register/complete') {
        process = BentoSMB.Function.InitRegisterComplete;
        track = BentoSMB.Track.RegisterTrack;
        conclude = BentoSMB.Function.RedirectRegisterComplete;
    }
}

function initTracking () {
    const container = document.querySelector('head');

    const trackElement = new DOMParser()
        .parseFromString(track, 'text/html');

    const {children} = trackElement.head;
    container.appendChild(...children);

    for (const child of children) {
        eval(child.innerHTML);
    }
}

init();
if (track !== null) initTracking();
if (process !== null) {
  if (timeout !== null) {
    setTimeout(process, timeout);
  } else {
    process();
  }
}


// BENTOSMB

// var DEFAULT_PHONE_NUMBER = '+18336284272';

// console.l = (...args) => {
//     console.log('APP::', ...args);
// }

// class NGC {
//     constructor() {
//         this.jurisdictionConfig = null;
//         this.jurisdictionConfigMap = null;

//         if (Shopify.designMode) {
//             this._watch();
//         }
        
//         this._init();
//     }

//     _watch() {
//         document.addEventListener('shopify:section:load', () => {
//             this._init();
//         });
//     }

//     _init() {
//         this._mapJursidictionConfigs();
//         this._setJurisdictionConfig();
//         this._setJurisdictionCollectionTagMap();

//         this._renderCityOptions();

//         if (this.jurisdictionConfig === undefined) {
//             return;
//         }

//         this._checkServicesPageAccess();
//         this._hideProducts();
//         this._hideServices();
//         this._observeSearchForm();
//         this._updatePhoneNumbers();
//         this._updatePhysicalStorefronts();
//         this._updateRebates();
//     }

//     _attempt(func, attempts = 0, _max_attempts = 10, _delay = 500) {
//         try {
//             func.call(this);
//         } catch (err) {
//             // console.error(err);

//             if (attempts >= _max_attempts) return;
//             setTimeout(this._attempt.bind(this, func, attempts + 1, _max_attempts, _delay), _delay);
//         }
//     }

//     _mapJursidictionConfigs() {
//         // const configMap = null;
//         const configMap = jurisdiction_config;
//         console.l(configMap);

//         this.jurisdictionConfigMap = Object.values(configMap);
//     }

//     _setJurisdictionConfig() {
//         let customerJurisdiction = null;
//         if (typeof Cookies === 'function') {
//             customerJurisdiction = Cookies.get('cust_jurisdiction');
//         }

//         if (typeof customerJurisdiction !== 'string') {
//             customerJurisdiction = "";
//         }

//         this.jurisdictionConfig = this.jurisdictionConfigMap.find(item => item.name.toLowerCase() === customerJurisdiction.toLowerCase());

//         if (this.jurisdictionConfig === undefined) {
//             return;
//         }

//         this.jurisdictionConfig.cityGroupItems = [];
//         if (this.jurisdictionConfig.children.length > 0) {
//             this.jurisdictionConfig.cityGroupItems.push(this.jurisdictionConfig);

//             for (const item of this.jurisdictionConfigMap) {
//                 if (this.jurisdictionConfig.children.includes(item.uid)) {
//                     this.jurisdictionConfig.cityGroupItems.push(item);
//                 }
//             }
//         } else if (this.jurisdictionConfig.parent !== '') {
//             for (const item of this.jurisdictionConfigMap) {
//                 if (item.parent === this.jurisdictionConfig.parent) {
//                     this.jurisdictionConfig.cityGroupItems.push(item);
//                 } else if (item.uid === this.jurisdictionConfig.parent) {
//                     this.jurisdictionConfig.cityGroupItems.push({
//                         ...item,
//                         isParent: true,
//                     });
//                 }
//             }
//         }
//     }

//     _setJurisdictionCollectionTagMap() {
//         // const collectionTagMap = null;
//         const collectionTagMap = jurisdiction_collection_tag_map;
//         console.l(collectionTagMap);

//         this.jurisdictionCollectionTagMap = collectionTagMap;
//     }

//     _updatePhoneNumbers() {
//         let config = this.jurisdictionConfig;
//         try {
//             const phoneNumber = this.jurisdictionConfig.phone;
//             if (typeof phoneNumber !== 'string' || phoneNumber.trim() === '') {
//                 const parentConfig = this.jurisdictionConfig.cityGroupItems.find(item => item.isParent === true);
//                 if (parentConfig === undefined) return;
//                 config = parentConfig
//             }
//         } catch {
//             return;
//         }

//         this._attempt(() => {
//             const elements = document.querySelectorAll('[phone-number]');

//             if (elements.length === 0) throw new Error();

//             elements.forEach(node => {
//                 node.innerHTML = config.phone;
//                 node.onclick = this._onClickPhoneNumber.bind(this, config);
//             });
//         }, undefined, undefined, 0);

//         this._attempt(() => {
//             const elements = document.querySelectorAll('[href="http://phone-number.com"]');

//             if (elements.length === 0) throw new Error();

//             elements.forEach(node => {
//                 node.removeAttribute('href');
//                 node.onclick = this._onClickPhoneNumberDefault;
//             });
//         }, undefined, undefined, 0);
//     }

//     _onClickPhoneNumber(config, event) {
//         event.preventDefault();
//         window.open(`tel:${config.cleanPhone}`, '_self');
//     }

//     _onClickPhoneNumberDefault(event) {
//         event.preventDefault();
//         window.open(`tel:${DEFAULT_PHONE_NUMBER}`, '_self');
//     }

//     _updatePhysicalStorefronts() {
//         this._attempt(() => {
//             const elements = document.querySelectorAll('[physical-storefronts]');

//             if (elements.length === 0) throw new Error();

//             const storefrontCities = [];
//             for (const item of this.jurisdictionConfig.cityGroupItems.reverse()) {
//                  if (item.hasStorefront === false) continue;

//                 if (item.storefrontPriority === undefined || item.storefrontPriority === 0) {
//                     storefrontCities.push({...item, storefrontPriority: 99999999});
//                 } else {
//                     storefrontCities.push(item);
//                 }
//             }

//             if (storefrontCities.length === 0) return;
//             const htmlElements = storefrontCities.sort((a, b) => {
//                 return a.storefrontPriority > b.storefrontPriority;
//             }).map(item =>
//                 this._renderStorefrontBlurbSection(
//                     item.storefrontHeading,
//                     item.storefrontName,
//                     item.storefrontAddress.replaceAll('\n', '<br />'),
//                     item.storefrontUrl
//                 )
//             ).join('');

//             elements.forEach(node => {
//                 node.innerHTML = htmlElements;
//             });
//         }, undefined, undefined, 10);
//     }

//     _updateRebates() {
//         this._attempt(() => {
//             const elements = document.querySelectorAll('[rebates]');

//             if (elements.length === 0) throw new Error();
//             if (this.jurisdictionConfig.rebates.length === 0) return;

//             const htmlElements = this._renderRebatesSection(
//                 this.jurisdictionConfig.rebates
//             );

//             elements.forEach(node => {
//                 node.innerHTML = htmlElements;
//             });
//         }, undefined, undefined, 10);
//     }

//     _renderRebatesSection(rebates) {
//         return (`
//             <p>
//                 ${rebates.map(item => `
//                     <span>• $${item.price.replace('.00', '')} for ${item.category.toLowerCase()}</span>
//                 `).join('<br />')}
//             </p>
//         `);
//     }

//     _renderStorefrontBlurbSection(heading, name, address, url) {
//         return (`
//             <div>
//                 <p style="margin: 0"><strong>${heading}</strong></p>
//                 <a href="${url}" title="View location of ${name}">
//                     <strong>${name}</strong>
//                 </a>
//                 <p>${address}</p>
//             </div>
//         `);
//     }

//     _hideProducts(_elements, _selector = () => null) {
//         this._attempt(() => {
//             const elements = _elements || document.querySelectorAll('[data-tag]');

//             if (elements.length === 0) throw new Error();

//             elements.forEach(node => this._toggleIfCurrentJurisdictionProduct(node));
//         }, undefined, undefined, 10);
//     }

//     _toggleIfCurrentJurisdictionProduct(node, _removeParent = true) {
//         console.log(node.dataset.tag, this.jurisdictionConfig.productFilter)
//         if (node.dataset.tag.includes(this.jurisdictionConfig.productFilter) === true) {
//             return;
//         }
        
//         if (_removeParent === true) {
//             node.parentNode.remove();
//         } else {
//             node.remove();
//         }
//     }

//     _observeSearchForm() {
//         this._attempt(() => {
//             const elements = document.querySelectorAll('form.search_form ul.search__results');

//             if (elements.length === 0) throw new Error();

//             const observerOptions = {
//                 childList: true,
//                 subtree: true,
//             };
//             const observer = new MutationObserver(this._handleSearchFormChanges.bind(this));

//             elements.forEach(node => {
//                 observer.observe(node, observerOptions);
//             });
//         }, undefined, undefined, 10);
//     }

//     _handleSearchFormChanges(records, observer) {
//         for (const record of records) {
//             for (const node of record.addedNodes) {
//                 this._toggleIfCurrentJurisdictionProduct(node, false);
//             }
//         }
//     }

//     _checkServicesPageAccess() {
//         const pathname = window.location.pathname;

//         if (this.jurisdictionConfig.hideAllProducts === true) {
//             const pathExclusions = ['/products', '/collection/', '/collections'];
//             if (
//                 pathExclusions.some(item =>
//                     pathname.includes(item)    
//                 )
//             ) {
//                 window.location.href = '/';
//             }
//         }

//         if (this.jurisdictionConfig.services.includes('rebates') === false) {
//             const pathExclusions = ['/pages/financing-rebates'];
//             if (
//                 pathExclusions.some(item =>
//                     pathname.includes(item)    
//                 )
//             ) {
//                 window.location.href = '/';
//             }
//         }

//         if (this.jurisdictionConfig.services.includes('financing') === false) {
//             const pathExclusions = ['/pages/financing-rebates', '/pages/we-ll-hook-you-up'];
//             if (
//                 pathExclusions.some(item =>
//                     pathname.includes(item)    
//                 )
//             ) {
//                 window.location.href = '/';
//             }
//         }
//     }

//     _hideServices() {
//         let hideAllProducts = this.jurisdictionConfig.hideAllProducts;
//         const collectionTagMap = this.jurisdictionCollectionTagMap[this.jurisdictionConfig.productFilter];
//         if (hideAllProducts === false) {
//             if(Array.isArray(collectionTagMap) === false || collectionTagMap.length === 0) {
//                 hideAllProducts = true;
//             }
//         }

//         if (true || hideAllProducts === true) {
//             // Remove specific links
//             const handleExclusions = ['shop-appliances'];
//             const handleExclusionSelectors = handleExclusions.map(item => `[data-link-handle="${item}"]`).join(',');
            
//             this._attempt(() => {
//                 const elements = document.querySelectorAll(handleExclusionSelectors);

//                 if (elements.length === 0) throw new Error();

//                 elements.forEach(node => {
//                     if (handleExclusions.includes(node.dataset.linkHandle) === false) {
//                         return;
//                     }

//                     node.remove();
//                 });
//             }, undefined, undefined, 10);

//             // Remove links based on prefix
//             const handlePrefixExclusions = ['collection_link::', 'collections_link::'];
//             const handlePrefixExclusionSelectors = handlePrefixExclusions.map(item => `[data-handle*="${item}"]`).join(',');
            
//             this._attempt(() => {
//                 const elements = document.querySelectorAll(handlePrefixExclusionSelectors);

//                 if (elements.length === 0) throw new Error();

//                 elements.forEach(node => {
//                     if (node.dataset.handle.includes(',') === true) {
//                         const items = node.dataset.handle.split(',');

//                         for (const item of items) {
//                             if (item === '') {
//                                 continue;
//                             }

//                             for (const prefix of handlePrefixExclusions) {
//                                 if (item.includes(prefix) === true) {
//                                     break;
//                                 }

//                                 return;
//                             }
//                         }
//                     }
//                     node.remove();
//                 });
//             }, undefined, undefined, 10);

//             // Remove specific sections
//             const sectionClassExclusions = ['figure.feature-section', '.custom-html-section'];
//             const sectionClassExclusionSelectors = sectionClassExclusions.join(',');
            
//             this._attempt(() => {
//                 const elements = document.querySelectorAll(sectionClassExclusionSelectors);

//                 if (elements.length === 0) throw new Error();

//                 elements.forEach(node => {
//                     const content = node.outerHTML.toLowerCase();

//                     if (
//                         content.includes('product') === false
//                         && content.includes('collection') === false
//                         && content.includes('shop now') === false
//                     ) {
//                         return;
//                     }

//                     node.remove();
//                 });
//             }, undefined, undefined, 10);
//         } else if (Array.isArray(collectionTagMap) === true) {
//             // Remove specific links based on product filter tag
//             this._attempt(() => {
//                 const elements = document.querySelectorAll('[data-handle*="collection_link::"]');

//                 if (elements.length === 0) throw new Error();

//                 elements.forEach(node => {
//                     if (collectionTagMap.some(
//                         item => node.dataset.handle.includes(item) === true
//                     ) === true) {
//                         if (collectionTagMap.includes(node.dataset.linkHandle) === false) {
//                             return;
//                         }
//                     }

//                     if (
//                         collectionTagMap.includes(node.dataset.linkHandle) === true
//                         || collectionTagMap.includes(node.dataset.objectHandle) === true
//                     ) {
//                         return;
//                     }

//                     if (typeof node.parentNode.parentNode.dataset.objectHandle === 'string') {
//                         if (node.parentNode.children.length === 1) {
//                             const arrowEl = node.parentNode.parentNode.querySelector('a > span[class*="arrow"]');

//                             if (arrowEl !== null) {
//                                 arrowEl.remove();
//                             }
//                         }                        
//                     }

//                     node.remove();
//                 });
//             }, undefined, undefined, 10);
//         }

//         if (this.jurisdictionConfig.services.includes('rebates') === false) {
//             // Remove specific rebate links
//             const handleExclusions = ['financing-rebates'];
//             const handleExclusionSelectors = handleExclusions.map(item => `[data-link-handle="${item}"]`).join(',');
            
//             this._attempt(() => {
//                 const elements = document.querySelectorAll(handleExclusionSelectors);

//                 if (elements.length === 0) throw new Error();

//                 elements.forEach(node => {
//                     if (handleExclusions.includes(node.dataset.linkHandle) === false) {
//                         return;
//                     }

//                     node.remove();
//                 });
//             }, undefined, undefined, 10);
//         }

//         if (this.jurisdictionConfig.services.includes('financing') === false) {
//             // Remove specific finance links
//             const handleExclusions = ['financing-rebates', 'we-ll-hook-you-up'];
//             const handleExclusionSelectors = handleExclusions.map(item => `[data-link-handle="${item}"]`).join(',');
            
//             this._attempt(() => {
//                 const elements = document.querySelectorAll(handleExclusionSelectors);

//                 if (elements.length === 0) throw new Error();

//                 elements.forEach(node => {
//                     if (handleExclusions.includes(node.dataset.linkHandle) === false) {
//                         return;
//                     }

//                     node.remove();
//                 });
//             }, undefined, undefined, 10);
//         }
//     }

//     _renderCityOptions() {
//         this._attempt(() => {
//             const element = document.querySelector('select#registrationmodal_cityselect');

//             if (element === null) throw new Error();

//             for (const item of this.jurisdictionConfigMap) {
//                 const optionElement = document.createElement('option');
//                 optionElement.setAttribute('class', 'registration_modal_select');
//                 optionElement.setAttribute('value', item.name);
//                 optionElement.setAttribute('data-jurisdiction', item.name);
//                 optionElement.innerHTML = item.name;

//                 element.append(optionElement);
//             }
//         }, undefined, undefined, 0);
//     }
// }

// window.addEventListener('DOMContentLoaded', () => {
//     typeof NGC !== 'undefined' && new NGC();
// });

